import { FC, HTMLAttributeAnchorTarget } from "react";
import Link from "@mui/material/Link";

export interface LinkProperties {
    url: string;
    text: String;
    label?: String;
    target?: HTMLAttributeAnchorTarget;
    styleLink?: Object;
    styleLabel?: Object;
    styleContent?: Object;
}

const ExternalLink: FC<LinkProperties> = ({
    url = "",
    text = "",
    label = "",
    target = "_blank",
    styleLink = {},
    styleLabel = {},
    styleContent = {},
}) => {
    return (
        <div style={styleContent}>
            {label && <span style={{ color: '#000',  ...styleLabel }}>{label}</span>}
            <div>
                <Link href={url} style={{ textDecoration: 'none',  ...styleLink }} target={target} rel="noreferrer">{text}</Link>
            </div>
        </div>
    )
}

export default ExternalLink;
